var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3010_14103)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#28A8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3863 5.34099L3.77045 10.9771C2.77298 11.3777 2.77875 11.9342 3.58744 12.1823L7.33991 13.3529L16.022 7.87506C16.4326 7.62528 16.8076 7.75965 16.4993 8.03333L9.4651 14.3817H9.46345L9.4651 14.3825L9.20625 18.2504C9.58545 18.2504 9.7528 18.0765 9.96548 17.8712L11.7881 16.0988L15.5793 18.8992C16.2784 19.2841 16.7804 19.0863 16.9544 18.252L19.4431 6.52311C19.6978 5.50174 19.0532 5.03927 18.3863 5.34099V5.34099Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3010_14103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e0a93cc7836b1d3a91682272ed27f313.svg";
export { ForwardRef as ReactComponent };